// helper
import { styleGenerator } from '../../helper';

// constants
import { G_TYPO, NU_TYPO, B_BG, FG_RADIUS } from './constants';

/**
 * Internal dependencies
 */
const { GlobalStyleHandler, generateTypographyStyles, generateBgStyles, generateResBoxStyles } = window.faqmateModules;

// Generate Dynamic Style
const DynamicStyle = props => {
    const { attributes, setAttributes } = props;
    const { uniqueId, titleColor } = attributes;

    // Gap

    //    // Global

    const { bgStyle: bBg } = generateBgStyles({
        controlName: B_BG,
        attributes
    });
    // Desktop Styles
    const deskStyles = `
         ${styleGenerator(`.${uniqueId} .faq-accordion-header`, [
             {
                 v: bBg
             },
         ])}
         
          
          
    `;
    const tabStyles = `
       
    `;
    const mobStyles = `
        
         
           
    `;

    return (
        <GlobalStyleHandler
            attributes={attributes}
            setAttributes={setAttributes}
            deskStyles={deskStyles}
            tabStyles={tabStyles}
            mobStyles={mobStyles}
        />
    );
};

export default DynamicStyle;
